























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";

@Component({
  components: {
    "user-groups-provider": () =>
      import("@/components/app/admin/userGroups/userGroupsProvider.vue"),
    "user-groups-table": () =>
      import("@/components/app/admin/userGroups/userGroupsTable.vue")
  }
})
export default class UserGroups extends Vue {
  @Prop({ default: () => ({}) })
  public declare manualFilters: Record<string, string | number | boolean>;

  @Prop({ default: () => ({}) })
  public availableFilters!: () => IFilter[];

  @Prop({ default: () => ({}) })
  public availableSorters!: () => ISorter[];

  public get cta() {
    if (!this.$userCan("create_user_group")) return null;
    return this.$t("_action.create_user_group");
  }
}
